import { combineReducers } from "redux";

import manageReducer from "./manageReducer";
import storeReducer from "./storeReducer";

export default combineReducers({
	manage: manageReducer,
	stores: storeReducer
})